import { inject, Injectable } from '@angular/core';
import { AuthService } from '@libs/shared/auth';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MainUserService {
  private readonly authService: AuthService = inject(AuthService);

  public isMainUserForCurrentCustomer(): Observable<boolean> {
    return this.authService.getCurrentCustomer().pipe(
      map((customer) => customer?.mainUser ?? false),
    );
  }
}

